export default "__VITE_ASSET__i23ZJfxL__"